export default __webpack_public_path__ + "static/media/Will of the Prescript.33462968.png";